import { TACGameState } from "../types";

export function isWaiting(gameState: TACGameState) {
  return (
    gameState === "waitingForDragging" ||
    gameState === "waitingForFlipping" ||
    gameState === "waitingForReplay"
  );
}
